import { useQuery } from '@tanstack/react-query';

import { useApi } from 'services/api';

const useCheckPcap = ({ tenantId, sensorId, pathType, recordId, enabled }) => {
  const api = useApi();

  const preparePcap = useQuery({
    queryKey: ['tenants', tenantId, 'smf', 'sensors', sensorId, pathType, recordId, 'pcap', 'prepare'],
    queryFn: ({ signal }) =>
      api.get(`/tenants/${tenantId}/smf/sensors/${sensorId}/${pathType}/${recordId}/pcap/prepare`, { signal }),
    enabled: Boolean(tenantId && sensorId && pathType && recordId) && enabled,
  });

  const checkPcap = useQuery({
    queryKey: ['tenants', tenantId, 'smf', 'sensors', sensorId, pathType, recordId, 'pcap'],
    queryFn: async ({ signal }) => {
      await api.head(`/tenants/${tenantId}/smf/sensors/${sensorId}/${pathType}/${recordId}/pcap`, { signal });

      return {
        status: true,
      };
    },
    enabled: Boolean(tenantId && sensorId && pathType && recordId) && enabled,
  });

  return {
    checkStatus: checkPcap.data?.status,
    pcapRule: preparePcap.data?.rule,
  };
};

export default useCheckPcap;
